import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { createElement } from "@wordpress/element";

/**
 * External dependencies
 */
import { isFunction } from 'lodash';
import classnames from 'classnames';
/**
 * WordPress dependencies
 */

import { Component } from '@wordpress/element';
import { withInstanceId } from '@wordpress/compose';
/**
 * Internal dependencies
 */

import FormToggle from '../form-toggle';
import BaseControl from '../base-control';

var ToggleControl =
/*#__PURE__*/
function (_Component) {
  _inherits(ToggleControl, _Component);

  function ToggleControl() {
    var _this;

    _classCallCheck(this, ToggleControl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ToggleControl).apply(this, arguments));
    _this.onChange = _this.onChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ToggleControl, [{
    key: "onChange",
    value: function onChange(event) {
      if (this.props.onChange) {
        this.props.onChange(event.target.checked);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          label = _this$props.label,
          checked = _this$props.checked,
          help = _this$props.help,
          instanceId = _this$props.instanceId,
          className = _this$props.className;
      var id = "inspector-toggle-control-".concat(instanceId);
      var describedBy, helpLabel;

      if (help) {
        describedBy = id + '__help';
        helpLabel = isFunction(help) ? help(checked) : help;
      }

      return createElement(BaseControl, {
        id: id,
        help: helpLabel,
        className: classnames('components-toggle-control', className)
      }, createElement(FormToggle, {
        id: id,
        checked: checked,
        onChange: this.onChange,
        "aria-describedby": describedBy
      }), createElement("label", {
        htmlFor: id,
        className: "components-toggle-control__label"
      }, label));
    }
  }]);

  return ToggleControl;
}(Component);

export default withInstanceId(ToggleControl);
//# sourceMappingURL=index.js.map